import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  Label,
  Modal
} from 'reactstrap';
import MyTerminal from './TtyShell';
import { bandModelWindowsOption } from '../utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import SpinnerCircles from './Spinner/SpinerCircles';
import { updateAssignedUsbsName, addOobCategory, getOobCategoryList } from '../actions/EpikBoxes';
import edit from "../Res/Icon/edit.png"
import AddOobCategoryModal from './AddOobCategoryModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomWarning from './CustomWarning';


const NoUsbText = 'Out of Band Management is enabled; however, there is no USB to Console connection found. Please check the USB connection and try again.'
const USB_SPEED_OPTIONS = [2400, 9600, 19200, 38400, 57600, 115200]
const headLabel = 'Out of Band Management';
const twoFaMethodOptions = [
  { label: 'Authenticator App', value: '2factorapp' },
  { label: 'SMS', value: 'sms' },
  { label: 'Email', value: 'email' }
]

const CustomInput = ({ name, onChangeInput = () => ({}), value, label, input, item, state = {}, ...props }) => (
  <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
    <Input
      name={name}
      type="radio"
      onChange={e => {
        onChangeInput(e.target.name, value);
        name === 'usb' && onChangeInput('usbSpeed', item.usbSpeed);
      }}
      checked={name === 'authPlatform' ? state.authPlatform === value : null}
      {...props}
    />
    {input ? (
      <Input
        name={item.id} type="text" defaultValue={item.label}
        onChange={e => {
          const updatedVal = {
            ...state.updatedUsbs,
            [e.target.name]: {
              ...state.updatedUsbs[item.id], customTitle: e.target.value
            }
          }
          onChangeInput('updatedUsbs', updatedVal);
        }}
      />
    ) :
      <span className='usb-simple-title'> {label}</span>
    }
  </div>
);

const DropdownInput = ({
  state,
  item,
  defaultValue = '',
  onChangeInput,
  optionsList = [],
  fieldName = 'usbCategory',
  addCategoryModal = () => ({})
}) => {

  return (
    <Input
      type="select"
      className="usb-speed-dropdown mb-2"
      style={{ width: 'auto' }}
      defaultValue={defaultValue}
      // defaultValue={{ label: "aestrt", value: '64d535e961d1b3de905cef77' }}
      onChange={e => {
        const updatedVal = {
          ...state.updatedUsbs,
          [item.id]: {
            ...state.updatedUsbs[item.id], [fieldName]: e.target.value
          }
        }
        onChangeInput('updatedUsbs', updatedVal);

      }}
    >
      {optionsList.map((option) => {
        return (
        <option key={option} value={option?.value ? option.value : option} selected={option?.value ? option.value === defaultValue : option === defaultValue}>
            {option.hasOwnProperty('label') ? option.label : option}
        </option>
        )
      })}
    </Input>
  )
}

const GetTwoFaModal = ({ state, onChangeInput, options, disconnectedUsbs }) => {

  const token = localStorage.getItem('jwtToken') || null;
  const box = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const dispatch = useDispatch()

  const [showDiDs, setShowDiDs] = useState(false);
  const checkDiscounted = (usb) => {
    return disconnectedUsbs.some(el => usb == el.portNo)
  }
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [catogriesList, setCatogriesList] = useState([]);

  useEffect(() => {
    getOobCategories()
  }, [])

  const cancelHandler = () => {
    setAddCategoryModal(false)
    setError('')
    setLoading(false);
    getOobCategories()
  }

  const getOobCategories = async () => {
    const response = await dispatch(getOobCategoryList(token, box._id, box.assignedTo._id));
    let catArray = []
    if (response) {
      (response || []).map(item => catArray.push({ label: item.title, value: item._id }))
      setCatogriesList(catArray)
    }
  }
  const addNewCategoryHandler = async (inputText) => {
    setLoading(true)
    const params = { company: box.assignedTo._id, categoryTitle: inputText }
    const res = await dispatch(addOobCategory(token, box._id, params));
    console.log('respone is ', res);
    if (res.error) {
      setError(res.error)
    } else if (res?.data) {
      setError('')
      setSuccess('Category added.');
      setTimeout(() => {
        setSuccess('')
      }, 2000)
    }
    setLoading(false)
  }

  return (
    <>
      <div className='d-flex justify-content-between align-item-center'>
        <label className='modal-clr-heading'>{headLabel}</label>
        <div className='d-flex align-item-center'>
          {state.editOption && <Button
            color="primary"
            style={{ width: 28, height: 28 }}
            className="d-flex align-item-center justify-content-center mr-3"
            onClick={() => setAddCategoryModal(true)}
            title={'Add New Category'}
          >
            <FontAwesomeIcon
              icon="plus"
              size="sm"
              // color="#29a4ff"
              color="#fff"
              style={{ verticalAlign: 'center' }}
            />
          </Button>}
          <div className=''>
            <Label>View Assigned DIDs</Label>
            <input
              className='mt-2 ml-2 cursor-pointer'
              type="checkbox"
              checked={showDiDs}
              onChange={(e) => setShowDiDs(!showDiDs)}
            />
        </div>
        </div>
      </div>
      <div className="band-management-container">
        <div className="management-container-1">
          <table className=" border-none width-auto">
            {state.editOption && (
              <tr>
                <td></td>
                <td className='pl-3'>Speed</td>
                <td className='pl-3'>Category</td>
              </tr>
            )}
            {options.map(item => (
              <tr>
                <td style={{ width: '50%' }}>
                  <CustomInput
                    name="usb"
                    value={item.value}
                    label={item.label}
                    key={item.value}
                    input={state.editOption}
                    onChangeInput={(name, value) => onChangeInput(name, value)}
                    item={item}
                    state={state}
                    disabled={checkDiscounted(item.value)}
                  />
                </td>
                {state.editOption && (
                  <td className='pl-3 pr-3'>
                    <DropdownInput
                      key={item}
                      state={state}
                      item={item}
                      optionsList={USB_SPEED_OPTIONS}
                      defaultValue={`${item?.usbSpeed ? item.usbSpeed : '9600'}`}
                      fieldName='usbSpeed'
                      onChangeInput={(name, value) => onChangeInput(name, value)} />
                  </td>
                )}
                {state.editOption && (
                  <td className='pl-3 pr-3'>
                    <DropdownInput
                      key={item}
                      state={state}
                      item={item}
                      defaultValue={item?.usbCategory?._id ? `${item?.usbCategory?._id}` : ''}
                      fieldName='usbCategory'
                      optionsList={catogriesList || []}
                      onChangeInput={(name, value) => onChangeInput(name, value)}
                      addCategoryModal={setAddCategoryModal}
                    />
                  </td>
                )}
                {showDiDs && (
                  <td>
                    <Label className='usb-number'>
                      {item.number && `(${item.number})`}
                      {checkDiscounted(item.value) && <span className='disconnected-text pl-2'>Disconnected</span>}
                    </Label>
                  </td>
                )}
              </tr>
            ))}
          </table>
        </div>

        <div className='management-container-2'>
          <label className='ft-16 mt-3 mb-3'> 2FA Method </label>
          <div className='management-container-2a'>
            {/* {user.twoFactor && <CustomInput name="authPlatform" value={'2factorapp'} label={'Authenticator App'} state={state}
              onChangeInput={onChangeInput} />} */}
            {
              twoFaMethodOptions.map((option, key) => {
                const inputComponent = <CustomInput
                  name="authPlatform"
                  value={option.value}
                  label={option.label}
                  state={state}
                  onChangeInput={onChangeInput} />

                if (option.value === '2factorapp') {
                  return (user.twoFactor ? inputComponent
                    : '')
                }
                return (inputComponent)
              })
            }
          </div>
        </div>
      </div>
      {addCategoryModal &&
        <AddOobCategoryModal
          error={error}
          success={success}
          isOpen={addCategoryModal}
          loading={loading}
          onSubmit={addNewCategoryHandler}
          cancelHandler={cancelHandler}
        />
      }
    </>);
};

const TwoFaAuthInput = (state, onChangeInput) => (
  <>
    <label className='modal-clr-heading'>{headLabel}</label>
    <div className='management-2fa-container'>
      <div><label>Enter 2FA Code </label></div>
      <div>
        <Input
          type="text"
          value={state.otp}
          onChange={e => onChangeInput('otp', e.target.value)}
        />
      </div>
    </div>
  </>
);

const initialState = (user = {}) => ({
  usb: '',
  authPlatform: user.twoFactor ? '2factorapp' : user.phoneNumber ? 'sms' : 'email',
  otp: '',
  loading: false,
  twoFaId: null,
  editOption: false,
  updatedUsbs: {},
  categories: [],
  usbSpeed: '',
  usbCategory: '',
});
const BandManagementModal = ({
  isOpen,
  onCancel,
  loading,
  sendFA,
  OnAuthenticateFA,
  bandModelWindow,
  twoFaRes,
}) => {


  const token = localStorage.getItem('jwtToken') || null;
  const box = useSelector(state => state.AppState.boxDetails.box);
  const oobList = useSelector(state => state.AppState.boxDetails.oobList);
  const user = useSelector(state => state.AppState.user);

  const [options, setOptions] = useState([
    // { label: 'Web SSH', value: 'webSSH' },
  ])
  const dispatch = useDispatch()
  const [state, setState] = useState(initialState(user));
  const [disconnectedUsbs, setDisconnectedUsbs] = useState([]);


  const isTTY = bandModelWindow === bandModelWindowsOption.ttyShell;
  const [time, setTime] = useState(null)
  const [timeoutWarning, setTimeoutWarning] = useState(false)
  const [increaseTerminalLife, setIncreaseTerminalLife] = useState(false)

  useEffect(() => {
    if (twoFaRes && twoFaRes._id)
      setState(state => ({ ...state, twoFaId: twoFaRes._id }))
  }, [twoFaRes])

  useEffect(() => {
    const newOobList = [];
    const assignedUsbs = oobList?.assignedUsbs;
    const disconnectedUsbs = oobList?.disconnectedUsbs;
    (assignedUsbs || []).map(ob =>
      newOobList.push({
        label: ob.customTitle,
        value: ob.portNo,
        number: ob.numberRef.number,
        id: ob._id,
        usbSpeed: ob.usbSpeed,
        usbCategory: ob.usbCategory,
      }),
    );

    setState(pre => ({
      ...pre,
      loading: false,
    }));
    setDisconnectedUsbs(disconnectedUsbs);
    setOptions(newOobList)

  }, [oobList]);

  useEffect(() => {
    if (bandModelWindow === bandModelWindowsOption.ttyShell) {
      setTime({ m: 4, s: 59 }) //start countdown for termianl connection
    }
  }, [bandModelWindow])

  const onChangeInput = (key, value) => {
    setState(preState => ({
      ...preState,
      [key]: value,
    }));
  };

  const onGoHandler = () => {
    if (state.editOption && Object.keys(state.updatedUsbs).length) {
      setState(pre => ({
        ...pre,
        loading: true,
      }))
      setTimeout(() => {
        onUpdateUsbsName()
      }, 500)
    } else {
      // send2FA
      const { usb, authPlatform, otp } = state;
      if (bandModelWindow === bandModelWindowsOption.faAuth) {
        // if (otp) OnAuthenticateFA({ ...state, authPlatform: '2factorapp' });
        if (otp) OnAuthenticateFA(state);
      } else if (bandModelWindow === bandModelWindowsOption.faInput) {
        if (usb && authPlatform) {
          sendFA(state);
        }
      }
    }
  };


  const [forceClose, setForceClose] = useState(false)
  const ttyCloseHandler = () => {
    setForceClose(true)
  }

  const onCancelClick = () => {
    if (bandModelWindow === bandModelWindowsOption.ttyShell) {
      // setSessionEnd(true)
      // return
    }
    setState(initialState());
    setTimeoutWarning(false)
    setForceClose(false)
    onCancel();
  };

  const onUpdateUsbsName = async () => {
    const res = await dispatch(updateAssignedUsbsName(token, box._id, state.updatedUsbs));
    if (res) {
      setState(pre => ({
        ...pre,
        loading: false,
        editOption: false,
        updatedUsbs: {}
      }))
    } else {
      setState(pre => ({
        ...pre,
        loading: false,
      }))
    }
  };

  useEffect(() => {
    if (time) {
      const interval = setInterval(() => {
        if (time.m == 0 && time.s == 1) {
          console.log("clear interval")
          clearInterval(interval)
          setTimeoutWarning(false)
          setTime(null)
        }
        else if (time.s == 0) {
          setTime(pre => ({ ...pre, m: time.m - 1, s: 59 }))
        } else {
          if (time.m == 0 && time.s == 31) { //show warning on 30sec left
            console.log("show war minutes")
            setTimeoutWarning(true)
          }
          setTime(pre => ({ ...pre, s: time.s - 1 }))
        }
      }, 1000);
      return () => clearInterval(interval)
    }
  }, [time])

  return (
    <Modal isOpen={isOpen} style={{ maxWidth: isTTY ? '90%' : '50%' }}>
      <div style={{ minHeight: isTTY ? '90vh' : '50vh' }} className="band-management-container">
        {options.length === 0 && <label className='modal-clr-heading'>{headLabel}</label>}
        {state.loading ?
          (
            <SpinnerCircles red />
          ) : (
            bandModelWindow === bandModelWindowsOption.faInput) ? (
              options.length > 0 ?
                <GetTwoFaModal
                  options={options}
                  state={state}
                  onChangeInput={onChangeInput}
                  disconnectedUsbs={disconnectedUsbs}
                /> :
                <h2 className='no-usb-text'><span>{NoUsbText}</span></h2>
          ) : (
            bandModelWindow === bandModelWindowsOption.faAuth) ? (
                TwoFaAuthInput(state, onChangeInput)
          ) : (
            bandModelWindow === bandModelWindowsOption.webSSH) ? (
            <iframe src="http://10.15.43.125:10250/" height={400} width="100%" />
          ) : (
            isTTY &&
            state.twoFaId &&
            state.usb && (
                    <MyTerminal
                      twoFaId={state.twoFaId}
                      usb={state.usb}
                      vpnAddress={box.vpnAddress}
                      usbSpeed={state.usbSpeed}
                      onCloseClick={onCancelClick}
                      setIncreaseTerminalLife={setIncreaseTerminalLife}
                      increaseTerminalLife={increaseTerminalLife}
                      setTime={setTime}
                      forceClose={forceClose}

                    />
            )
          )
        }

        {options.length > 0 ? 
          <div
            className='management-modal-btn-section mt-2'
            style={{ justifyContent: bandModelWindow === bandModelWindowsOption.ttyShell ? 'flex-start' : 'flex-end' }}
          >
            {
              (bandModelWindow !== bandModelWindowsOption.webSSH) &&
              <Button outline onClick={(bandModelWindow === bandModelWindowsOption.ttyShell) ? ttyCloseHandler : onCancelClick}>
                {(bandModelWindow === bandModelWindowsOption.ttyShell) ? "Close" : 'Cancel'}
              </Button>
            }
            {
              (bandModelWindow === bandModelWindowsOption.faInput || bandModelWindow === bandModelWindowsOption.faAuth) &&
              (
                <Button color="primary" disabled={loading || state.loading} onClick={onGoHandler} className="ml-2">
                  {state.editOption ? 'Save' : 'Connect'}
                </Button>
              )
            }
          </div> 
          :
          <Button outline onClick={onCancelClick}>Close</Button>
        }

        {(!state.loading && bandModelWindow === bandModelWindowsOption.faInput && options.length > 0) &&
          <img
            onClick={() => {
              onChangeInput('editOption', !state.editOption);
            }}
            className="actions-icon"
            src={edit}
            alt="..."
          />
        }
      </div>
      <CustomWarning
        isOpen={timeoutWarning}
        onConfirm={() => {
          setTimeoutWarning(false)
          setIncreaseTerminalLife(true)
        }}
        customText="Dismiss"
      >
        Your OOBM session is about to close in  <b>{time?.s} Seconds </b>due to inactivity. Please dismiss this message to continue; otherwise, the session will be closed.
      </CustomWarning>

    </Modal>
  );
};

export default React.memo(BandManagementModal);

